module.exports = __webpack_public_path__ + "img/machineThre-img5.9e5af833.jpg";